import * as React from 'react';
import { TButtonSize } from '@cian/ui-kit/button/types';

import { useSelector } from 'react-redux';
import { getBuilderChatEnabled } from '../../selectors/builderChat';
import { BuilderChatButtonContainer } from '../BuilderChatButton';
import { ConsultantChatButtonContainer } from '../ConsultantChatButtonContainer';

interface IMessageButtonContainerProps {
  isHeaderButton?: boolean;
  buttonSize?: TButtonSize;
}

/**
 * Развилка для кнопок, открывающих разные виды чатов.
 */
export const MessageButtonContainer: React.FC<IMessageButtonContainerProps> = props => {
  const isChatEnabled = useSelector(getBuilderChatEnabled);

  if (!isChatEnabled) {
    return <ConsultantChatButtonContainer {...props} />;
  }

  return <BuilderChatButtonContainer {...props} />;
};
